if (!customElements.get('cart-suggestion')) {
  customElements.define(
    'cart-suggestion',
    class CartSuggestion extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.cart-suggestion__add');
        this.cart = document.querySelector('cart-drawer');
        if (!this.button) return;
        this.button.addEventListener('click', this.onAddClick.bind(this));
      }

      onAddClick(evt) {
        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.button.dataset.variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'cart-suggestion',
                productVariantId: this.button.dataset.variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-suggestion',
              productVariantId: this.button.dataset.variantId,
              cartData: response,
            });

            // Same drawer refresh used by the main Add to Cart form: a full
            // section re-render, which both removes this suggestion (the
            // Liquid conditions re-evaluate against the updated cart) and
            // updates the free-delivery progress bar in one swap -- no
            // separate DOM-removal logic needed here.
            if (this.cart) this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            this.button.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }
    }
  );
}
